import { render, staticRenderFns } from "./BaseErrorContainer.vue?vue&type=template&id=551bb623"
import script from "./BaseErrorContainer.vue?vue&type=script&lang=js"
export * from "./BaseErrorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports